// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d81e0b6","508":"d3d493bc","760":"0544aa86","806":"fbb13be6","849":"0579aa7e","853":"ce3a8abf"}[chunkId] + ".chunk.js";
};